// Italian translations
const it = {
  // Common
  common: {
    loading: "Caricamento...",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    create: "Crea",
    search: "Cerca",
    filter: "Filtra",
    export: "Esporta",
    back: "Indietro",
    next: "Avanti",
    confirm: "Conferma",
    close: "Chiudi",
    yes: "Sì",
    no: "No",
    all: "Tutti",
    none: "Nessuno",
    actions: "Azioni",
    status: "Stato",
    date: "Data",
    amount: "Importo",
    total: "Totale",
    subtotal: "Subtotale",
    tax: "IVA",
    discount: "Sconto",
    currency: "Valuta",
    description: "Descrizione",
    details: "Dettagli",
    settings: "Impostazioni",
    logout: "Esci",
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    username: "Nome o Username",
    name: "Nome",
    phone: "Telefono",
    address: "Indirizzo",
    language: "Lingua",
    selectLanguage: "Seleziona lingua",
    backup: "Backup",
    support: "Supporto",
  },

  // Landing Page
  landing: {
    heroTitle: "Accetta Pagamenti",
    heroTitleHighlight: "Ovunque",
    heroSubtitle: "Crea link di pagamento, fatture automatiche e integra le API in pochi minuti. Tutto con il tuo brand personalizzato.",
    getStarted: "Inizia Gratuitamente",
    startFree: "Inizia Gratis",
    accessDashboard: "Accedi alla Dashboard",
    smartPaymentGateway: "Gateway di Pagamento Intelligente",
    features: {
      title: "Tutto ciò che ti serve per accettare pagamenti",
      subtitle: "Una piattaforma completa per gestire i tuoi pagamenti online, con funzionalità avanzate e sicurezza garantita.",
      learnMore: "Scopri di più",
      paymentLinks: {
        title: "Link di Pagamento",
        description: "Crea link di pagamento personalizzati in pochi secondi. QR code incluso."
      },
      invoicing: {
        title: "Fatturazione Integrata",
        description: "Genera fatture professionali con link di pagamento automatico."
      },
      api: {
        title: "API Potenti",
        description: "Integra i pagamenti nelle tue applicazioni con le nostre API REST."
      },
      security: {
        title: "Sicurezza Totale",
        description: "Crittografia end-to-end e conformità agli standard di sicurezza."
      },
      agents: {
        title: "Rete Agenti",
        description: "Costruisci la tua rete di partner e guadagna commissioni."
      },
      analytics: {
        title: "Analytics Avanzati",
        description: "Monitora le tue transazioni con dashboard in tempo reale."
      }
    },
    benefits: {
      title: "Perché scegliere Hola Pay?",
      subtitle: "Siamo la soluzione ideale per merchant che vogliono accettare pagamenti in modo semplice, sicuro e professionale.",
      noSetupFee: "Nessun costo di setup",
      transparentFees: "Commissioni trasparenti",
      multiCurrency: "Supporto multi-valuta",
      whiteLabel: "White-label completo",
      customDashboard: "Dashboard personalizzabile",
      realTimeWebhook: "Webhook in tempo reale"
    },
    cta: {
      title: "Pronto a iniziare?",
      subtitle: "Crea il tuo account gratuito e inizia ad accettare pagamenti in pochi minuti.",
      button: "Crea Account Gratuito"
    },
    pos: {
      badge: "Prossimamente",
      title: "Terminali POS",
      titleHighlight: "Hola Pay",
      subtitle: "Accetta pagamenti ovunque con i nostri terminali di ultima generazione. Contactless, chip & PIN, pre-autorizzazioni per hotel e autonoleggi.",
      feature1: "Transazioni in meno di 2 secondi",
      feature2: "Massima sicurezza con crittografia end-to-end",
      feature3: "Accetta tutte le carte internazionali",
      feature4: "Dashboard unificata con tutti i tuoi incassi",
      cta: "Registrati per essere avvisato"
    },
    footer: {
      rights: "Tutti i diritti riservati."
    }
  },

  // Auth
  auth: {
    welcomeBack: "Bentornato!",
    loginSubtitle: "Accedi al tuo account per gestire i pagamenti",
    createAccount: "Crea il tuo account",
    registerSubtitle: "Inizia ad accettare pagamenti in pochi minuti",
    businessName: "Nome Attività",
    usernameOptional: "Nome (facoltativo)",
    forgotPassword: "Hai dimenticato la password?",
    noAccount: "Non hai ancora un account?",
    hasAccount: "Hai già un account?",
    loginButton: "Accedi",
    registerButton: "Crea Account",
    loggingIn: "Accesso in corso...",
    registering: "Creazione account...",
    loginSuccess: "Accesso effettuato!",
    registerSuccess: "Account creato con successo!",
    invalidCredentials: "Credenziali non valide",
    serviceUnavailable: "Servizio temporaneamente non disponibile",
    registrationError: "Errore durante la registrazione",
    registrationSuspendedTitle: "Registrazioni temporaneamente sospese",
    registrationSuspendedMessage: "La creazione di nuovi account merchant è momentaneamente sospesa. Riprova più tardi o contatta il supporto.",
    contactSupport: "Contatta il supporto",
    close: "Chiudi",
    registrationStatusLoading: "Verifica della disponibilità delle registrazioni…",
    registrationStatusError: "Non è stato possibile verificare lo stato delle registrazioni. Per sicurezza, il modulo resta disattivato.",
    registrationStatusRetry: "Riprova",
    registrationSuspendedDetails: "Mostra i dettagli",
    backToHome: "Torna alla Home",
    backToLogin: "Torna al Login",
    demoCredentials: "Demo Admin:",
    // Forgot Password
    forgotPasswordTitle: "Password Dimenticata?",
    forgotPasswordSubtitle: "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
    sendResetLink: "Invia Link di Reset",
    sending: "Invio in corso...",
    emailSent: "Email Inviata",
    emailSentMessage: "Se l'indirizzo email è associato a un account, riceverai un link per reimpostare la password.",
    // Reset Password
    resetPasswordTitle: "Reimposta Password",
    resetPasswordSubtitle: "Inserisci la tua nuova password.",
    newPassword: "Nuova Password",
    confirmPassword: "Conferma Password",
    resetButton: "Reimposta Password",
    resetting: "Reimpostazione...",
    passwordReset: "Password Reimpostata!",
    passwordResetSuccess: "La tua password è stata reimpostata con successo. Ora puoi accedere con la nuova password.",
    goToLogin: "Vai al Login",
    invalidLink: "Link Non Valido",
    invalidLinkMessage: "Il link di reset password non è valido. Richiedi un nuovo link.",
    expiredLink: "Link Scaduto",
    expiredLinkMessage: "Il link di reset password è scaduto o non è valido. Richiedi un nuovo link.",
    requestNewLink: "Richiedi Nuovo Link",
    passwordMinLength: "Minimo 8 caratteri",
    passwordsNotMatch: "Le password non corrispondono",
    passwordTooShort: "La password deve essere di almeno 8 caratteri",
    // Change Password
    changePasswordTitle: "Cambia Password",
    changePasswordSubtitle: "Inserisci la password attuale e la nuova password.",
    currentPassword: "Password Attuale",
    changeButton: "Cambia Password",
    changing: "Cambio in corso...",
    passwordChanged: "Password cambiata con successo!",
    changePasswordError: "Errore nel cambio password",
    mandatoryChange: "Cambio Password Obbligatorio",
    mandatoryChangeMessage: "Per motivi di sicurezza, devi cambiare la password al primo accesso.",
    registerBenefits: {
      title: "Inizia subito a ricevere pagamenti",
      noActivation: "Nessun costo di attivazione",
      quickSetup: "Setup in meno di 5 minuti",
      dashboardIncluded: "Dashboard completa inclusa"
    },
    loginBenefits: {
      title: "Gestisci i tuoi pagamenti con facilità",
      subtitle: "Dashboard completa per monitorare transazioni, creare link di pagamento e gestire le fatture."
    }
  },

  // Dashboard
  dashboard: {
    overview: "Overview",
    paymentLinks: "Link Pagamento",
    subscriptions: "Abbonamenti",
    invoices: "Fatture",
    transactions: "Transazioni",
    emailTransactionSearch: "Cerca per email",
    apiKeys: "API Keys",
    branding: "Branding",
    withdrawals: "Prelievi",
    settings: "Impostazioni",
    merchants: "Merchant",
    agents: "Agenti",
    gateways: "Gateway",
    auditLog: "Audit Log",
    terminals: "Terminali",
    merchantNetwork: "Rete Merchant",
  },

  // Merchant Dashboard
  merchant: {
    availableBalance: "Saldo Disponibile",
    pendingBalance: "In Attesa",
    totalCollected: "Totale Incassato",
    commissionsPaid: "Commissioni",
    quickActions: "Azioni Rapide",
    newPaymentLink: "Nuovo Link Pagamento",
    newInvoice: "Nuova Fattura",
    requestWithdrawal: "Richiedi Prelievo",
    transactionsChart: "Andamento Transazioni",
    completed: "Completate",
    failed: "Fallite",
    refunded: "Rimborsate",
    welcomeDashboard: "Benvenuto nella tua Dashboard",
    managePaymentsIn: "Gestisci i tuoi pagamenti in",
    withdraw: "Preleva",
    createPaymentLinkDesc: "Crea un link per ricevere pagamenti",
    createInvoiceDesc: "Genera una fattura professionale",
    transferFundsDesc: "Trasferisci i tuoi fondi",
    last7Days: "Ultimi 7 giorni",
  },

  // Payment Links
  paymentLinks: {
    title: "Link di Pagamento",
    subtitle: "Crea e gestisci i tuoi link di pagamento",
    createNew: "Nuovo Link",
    createTitle: "Crea Link di Pagamento",
    description: "Descrizione",
    descriptionPlaceholder: "Es: Pagamento consulenza",
    amount: "Importo (vuoto = libero)",
    currency: "Valuta",
    expiration: "Scadenza",
    createButton: "Crea Link",
    creating: "Creazione...",
    copyLink: "Copia link",
    showQR: "Mostra QR",
    openLink: "Apri link",
    deleteLink: "Elimina",
    linkCopied: "Link copiato!",
    linkCreated: "Link di pagamento creato!",
    linkDeleted: "Link eliminato",
    noLinks: "Nessun link creato",
    noLinksSubtitle: "Crea il tuo primo link di pagamento per iniziare a ricevere pagamenti",
    createFirst: "Crea il primo link",
    status: {
      active: "Attivo",
      paid: "Pagato",
      expired: "Scaduto"
    },
    openAmount: "Importo libero",
    created: "Creato",
    expires: "Scade",
    qrCode: "QR Code"
  },

  // Invoices
  invoices: {
    title: "Fatture",
    subtitle: "Crea e gestisci le tue fatture con link di pagamento",
    createNew: "Nuova Fattura",
    createTitle: "Crea Nuova Fattura",
    customerData: "Dati Cliente",
    customerName: "Nome Cliente",
    customerEmail: "Email Cliente",
    customerAddress: "Indirizzo",
    customerVat: "P.IVA / VAT",
    invoiceItems: "Voci Fattura",
    addItem: "Aggiungi",
    item: "Voce",
    itemDescription: "Descrizione servizio",
    quantity: "Quantità",
    unitPrice: "Prezzo Unit.",
    taxRate: "IVA %",
    discountAmount: "Sconto €",
    dueDate: "Scadenza",
    notes: "Note",
    notesPlaceholder: "Note aggiuntive...",
    createButton: "Crea Fattura",
    creating: "Creazione...",
    send: "Invia",
    view: "Visualizza",
    delete: "Elimina",
    invoiceSent: "Fattura inviata al cliente!",
    invoiceCreated: "Fattura creata!",
    invoiceDeleted: "Fattura eliminata",
    noInvoices: "Nessuna fattura",
    noInvoicesSubtitle: "Crea la tua prima fattura con link di pagamento integrato",
    createFirst: "Crea la prima fattura",
    status: {
      draft: "Bozza",
      sent: "Inviata",
      paid: "Pagata",
      expired: "Scaduta",
      cancelled: "Annullata",
      refunded: "Rimborsata"
    },
    from: "Da",
    to: "A",
    invoiceNumber: "Numero Fattura"
  },

  // Transactions
  transactions: {
    title: "Transazioni",
    subtitle: "Visualizza e gestisci tutte le tue transazioni",
    exportCSV: "Esporta CSV",
    id: "ID",
    date: "Data",
    amount: "Importo",
    commission: "Commissione",
    netAmount: "Netto",
    gateway: "Gateway",
    status: "Stato",
    noTransactions: "Nessuna transazione",
    noTransactionsSubtitle: "Le transazioni appariranno qui quando riceverai pagamenti",
    status_pending: "In attesa",
    status_completed: "Completata",
    status_failed: "Fallita",
    status_refunded: "Rimborsata",
    status_initialized: "Inizializzata",
    quickFilters: {
      today: "Oggi",
      week: "Settimana",
      month: "Mese"
    },
    removeDuplicates: "Rimuovi Duplicati",
    removing: "Rimozione...",
    markAsCompleted: "Segna come Completato",
    updating: "Aggiornamento...",
    adminAction: "Azione Admin"
  },

  // API Keys
  apiKeys: {
    title: "API Keys",
    subtitle: "Gestisci le tue chiavi API per l'integrazione",
    createNew: "Nuova API Key",
    createTitle: "Crea Nuova API Key",
    keyName: "Nome",
    keyNamePlaceholder: "Es: Produzione, Test",
    ipWhitelist: "IP Whitelist (opzionale)",
    ipWhitelistPlaceholder: "192.168.1.1, 10.0.0.1",
    ipWhitelistHint: "Separa gli IP con virgole",
    createButton: "Crea API Key",
    creating: "Creazione...",
    keyCreated: "API Key creata!",
    keyDeleted: "API Key eliminata",
    saveSecretKey: "Salva la Secret Key",
    secretKeyWarning: "Non sarà più visibile dopo aver chiuso questa finestra.",
    publicKey: "Public Key",
    secretKey: "Secret Key",
    keySaved: "Ho salvato le chiavi",
    noKeys: "Nessuna API Key",
    noKeysSubtitle: "Crea una API key per integrare i pagamenti nelle tue applicazioni",
    createFirst: "Crea la prima API Key",
    created: "Creata",
    lastUsed: "Ultimo uso",
    documentation: "Documentazione API",
    baseEndpoint: "Endpoint Base",
    authentication: "Autenticazione",
    authHint: "Aggiungi l'header Authorization alle tue richieste:"
  },

  // Branding
  branding: {
    title: "Branding",
    subtitle: "Personalizza l'aspetto dei tuoi link di pagamento e fatture",
    businessInfo: "Informazioni Azienda",
    displayName: "Nome Commerciale",
    legalName: "Ragione Sociale",
    email: "Email",
    phone: "Telefono",
    address: "Indirizzo",
    vatNumber: "P.IVA",
    visualCustomization: "Personalizzazione Visiva",
    logoUrl: "URL Logo",
    logoHint: "PNG, JPG o SVG. Dimensione consigliata: 200x200px",
    primaryColor: "Colore Primario",
    buttonColor: "Colore Pulsante",
    footerText: "Testo Footer",
    saveChanges: "Salva Modifiche",
    saving: "Salvataggio...",
    saved: "Branding aggiornato!",
    preview: "Anteprima",
    amountToPay: "Importo da pagare",
    payNow: "Paga Ora",
    securePayment: "Pagamento Sicuro"
  },

  // Withdrawals
  withdrawals: {
    title: "Prelievi",
    subtitle: "Gestisci le tue richieste di prelievo",
    requestNew: "Richiedi Prelievo",
    requestTitle: "Richiedi Prelievo",
    availableBalance: "Saldo disponibile",
    availableBalanceIn: "Saldo disponibile in",
    amount: "Importo",
    paymentMethod: "Metodo di Pagamento",
    bankTransfer: "Bonifico Bancario",
    crypto: "Criptovaluta",
    paypal: "PayPal",
    binance: "Binance",
    westernUnion: "Western Union",
    cash: "Contanti",
    iban: "IBAN",
    accountHolder: "Intestatario",
    paypalEmail: "Email PayPal",
    submitRequest: "Invia Richiesta",
    submitting: "Invio richiesta...",
    requestSubmitted: "Richiesta di prelievo inviata!",
    insufficientBalance: "Saldo insufficiente",
    noWithdrawals: "Nessun prelievo",
    noWithdrawalsSubtitle: "Le tue richieste di prelievo appariranno qui",
    requested: "Richiesto",
    availableForWithdrawal: "Saldo Disponibile per Prelievo",
    withdrawalDetails: "Dettagli Prelievo",
    withdrawalId: "ID Prelievo",
    commission: "Commissione",
    netAmount: "Importo Netto",
    selectNetwork: "Seleziona Network",
    walletAddress: "Indirizzo Wallet",
    binanceId: "Binance ID",
    recipientName: "Nome Destinatario",
    city: "Città",
    phone: "Telefono",
    notes: "Note",
    country: "Paese",
    status: {
      pending: "In attesa",
      approved: "Approvato",
      rejected: "Rifiutato",
      paid: "Pagato"
    }
  },

  // Admin Dashboard
  admin: {
    totalVolume: "Volume Totale",
    platformRevenue: "Revenue Piattaforma",
    activeMerchants: "Merchant Attivi",
    totalAgents: "Agenti",
    pendingWithdrawals: "richieste di prelievo in attesa",
    manage: "Gestisci",
    recentTransactions: "Transazioni Recenti",
    noTransactions: "Nessuna transazione",
    merchantManagement: "Gestione Merchant",
    agentManagement: "Gestione Agenti",
    withdrawalRequests: "Richieste di Prelievo",
    business: "Attività",
    commissionRate: "Commissione",
    agent: "Agente",
    noAgent: "Nessuno",
    createAgent: "Nuovo Agente",
    createAgentTitle: "Crea Nuovo Agente",
    agentCreated: "Agente creato!",
    noAgents: "Nessun agente",
    registrationDate: "Data Registrazione",
    approve: "Approva",
    reject: "Rifiuta",
    markPaid: "Segna Pagato",
    withdrawalApproved: "Prelievo approvato",
    withdrawalRejected: "Prelievo rifiutato",
    withdrawalPaid: "Prelievo pagato",
    noRequests: "Nessuna richiesta",
    merchantUpdated: "Merchant aggiornato"
  },

  // Agent Dashboard
  agent: {
    commissionsEarned: "Commissioni Maturate",
    commissionsAvailable: "Commissioni Disponibili",
    networkVolume: "Volume Rete",
    activeMerchants: "Merchant Attivi",
    merchantNetwork: "Rete Merchant",
    noMerchants: "Nessun merchant nella tua rete",
    recentNetworkTransactions: "Transazioni Recenti Rete",
    noTransactions: "Nessuna transazione"
  },

  // Public Payment Page
  payment: {
    amountToPay: "Importo da pagare",
    chooseMethod: "Scegli metodo di pagamento:",
    cardPayment: "Carta di Credito/Debito",
    enterAmount: "Inserisci importo",
    payWithPaypal: "Paga con PayPal",
    processing: "Elaborazione...",
    securePayment: "Pagamento sicuro con PayPal",
    paymentCompleted: "Pagamento Completato!",
    thankYou: "Grazie per il tuo pagamento. Riceverai una conferma via email.",
    paymentFailed: "Pagamento Fallito",
    errorOccurred: "Si è verificato un errore durante il pagamento. Riprova.",
    retry: "Riprova",
    linkExpired: "Link Scaduto",
    linkExpiredMessage: "Questo link di pagamento è scaduto.",
    alreadyPaid: "Già Pagato",
    alreadyPaidMessage: "Questo link di pagamento è già stato utilizzato.",
    invalidLink: "Link non valido",
    invalidLinkMessage: "Il link di pagamento non esiste o è scaduto."
  },

  // Public Invoice Page
  invoice: {
    invoice: "Fattura",
    from: "Da",
    to: "A",
    dueDate: "Scadenza",
    description: "Descrizione",
    qty: "Qtà",
    price: "Prezzo",
    total: "Totale",
    subtotal: "Subtotale",
    tax: "IVA",
    discount: "Sconto",
    notes: "Note",
    pay: "Paga",
    invoicePaid: "Fattura Pagata",
    paidOn: "Pagata il",
    toPay: "Da pagare"
  },

  // Statuses
  statuses: {
    pending: "In attesa",
    active: "Attivo",
    suspended: "Sospeso",
    approved: "Approvato",
    rejected: "Rifiutato",
    paid: "Pagato",
    completed: "Completato",
    failed: "Fallito",
    refunded: "Rimborsato",
    draft: "Bozza",
    sent: "Inviato",
    expired: "Scaduto",
    cancelled: "Annullato"
  },

  // Errors
  errors: {
    generic: "Si è verificato un errore",
    networkError: "Errore di rete",
    unauthorized: "Non autorizzato",
    forbidden: "Accesso negato",
    notFound: "Non trovato",
    serverError: "Errore del server",
    validationError: "Errore di validazione",
    requiredField: "Campo obbligatorio",
    invalidEmail: "Email non valida",
    invalidAmount: "Importo non valido",
    minLength: "Lunghezza minima: {min} caratteri",
    maxLength: "Lunghezza massima: {max} caratteri"
  },

  // Success messages
  success: {
    saved: "Salvato con successo",
    created: "Creato con successo",
    updated: "Aggiornato con successo",
    deleted: "Eliminato con successo",
    copied: "Copiato!"
  },

  // Crypto Payout
  cryptoPayout: {
    title: "Crypto Payout",
    subtitle: "Payout USDC/USDT/USDA su Polygon",
    merchantSubtitle: "Ricevi i tuoi incassi in USDC/USDT/USDA su Polygon",
    systemActive: "Attivo",
    systemInactive: "Disattivo",
    refresh: "Aggiorna",
    // Tabs
    tabs: {
      overview: "Home",
      settings: "Impostazioni",
      merchants: "Merchant",
      queue: "Coda",
      history: "Storico"
    },
    // Overview
    walletBalance: "Saldo Wallet",
    notConfigured: "Non configurato",
    belowThreshold: "Sotto soglia",
    completed: "Completati",
    inQueue: "In Coda",
    merchants: "Merchant",
    outOf: "su",
    realTimeRates: "Tassi Real-Time",
    loading: "Caricamento...",
    recentPayouts: "Ultimi Payout",
    noPayout: "Nessun payout",
    // Settings
    settings: "Impostazioni",
    systemEnabled: "Sistema Attivo",
    automaticPayouts: "Payout automatici",
    adminWallet: "Wallet Admin (Polygon)",
    walletDescription: "Wallet per inviare USDC/USDT/USDA ai merchant.",
    privateKey: "Private Key (AES-256)",
    configured: "Configurata",
    privateKeyWarning: "Crittografata AES-256. Usa wallet dedicato.",
    alertThreshold: "Soglia Alert ($)",
    alertDescription: "Alert Telegram quando saldo < soglia.",
    telegramAlerts: "Alert Telegram",
    payoutNotifications: "Notifiche payout",
    saveSettings: "Salva Impostazioni",
    settingsSaved: "Impostazioni salvate",
    // Merchants
    merchantsTitle: "Merchant / Agente",
    wallet: "Wallet",
    token: "Token",
    frequency: "Freq.",
    payoutMode: "Modalità payout",
    automaticMode: "Automatico",
    manualMode: "Approvazione manuale",
    payoutModeHint: "Questa impostazione si applica solo ai nuovi intenti di payout.",
    roxpayManualApprovals: "Approvazioni manuali RoxPay",
    roxpayManualApprovalDescription: "Richiedono approvazione prima dell’invio solo i payout RoxPay configurati in modalità manuale.",
    status: "Stato",
    action: "Azione",
    on: "ON",
    off: "OFF",
    config: "Config",
    configCryptoPayout: "Config Crypto Payout",
    polygonWallet: "Wallet Polygon",
    optional: "Opzionale",
    walletOptionalHint: "Se non inserito, il merchant potrà configurarlo dalla sua dashboard",
    enable: "Abilita",
    cancel: "Annulla",
    merchantEnabled: "Merchant abilitato per crypto payout",
    merchantDisabled: "Merchant disabilitato",
    // Frequency
    everyTransaction: "Ogni TX",
    daily: "Giornaliero",
    weekly: "Settimanale",
    biweekly: "Ogni 15 giorni",
    monthly: "Mensile",
    // Queue
    queueTitle: "Payout in Coda",
    retryAll: "Riprova payout in coda",
    retryNoEligible: "Nessun payout in coda idoneo al retry",
    retryNoCompleted: "Nessun payout confermato; verifica lo stato prima di riprovare",
    retryAlreadyClaimed: "Un altro worker ha già preso in carico il payout; nessun nuovo retry avviato",
    retrySkipped: "Saltati",
    pendingReview: "Da verificare",
    pendingNeedsReview: "Le voci pending non vengono reinviate automaticamente: verifica lo storico e lo stato on-chain per evitare duplicati",
    fiatAmount: "Importo Fiat",
    cryptoAmount: "Importo Crypto",
    rate: "Tasso",
    date: "Data",
    waiting: "In attesa",
    noQueuePayouts: "Nessun payout in coda",
    retryCompleted: "Completati",
    retryFailed: "Falliti",
    // History
    historyTitle: "Storico Payout",
    fiat: "Fiat",
    crypto: "Crypto",
    txHash: "TX Hash",
    completedStatus: "Completato",
    failedStatus: "Fallito",
    noHistoryPayouts: "Nessun payout completato",
    // Merchant Settings Page
    merchantPage: {
      title: "Payout Crypto",
      subtitle: "Ricevi i tuoi incassi in USDC/USDT/USDA su Polygon",
      active: "Attivo",
      notConfigured: "Non configurato",
      systemNotActive: "Sistema non ancora attivo",
      systemNotActiveDesc: "Il sistema di payout crypto non è ancora stato attivato dall'amministratore. Potrai configurare il tuo wallet, ma i payout non saranno effettuati fino all'attivazione.",
      notAvailable: "Crypto Payout Non Disponibile",
      notAvailableDesc: "Questa funzionalità non è ancora abilitata per il tuo account. Contatta l'amministratore per richiedere l'attivazione dei payout in criptovaluta.",
      liveRates: "Tassi di Cambio Live",
      source: "Fonte",
      updated: "Aggiornato",
      example: "Esempio",
      configuration: "Configurazione",
      yourWallet: "Il tuo Wallet Polygon",
      walletPlaceholder: "Inserisci l'indirizzo del tuo wallet Polygon (MetaMask, Trust Wallet, etc.)",
      preferredToken: "Token preferito",
      payoutFrequency: "Frequenza payout",
      setByAdmin: "Impostato da Admin",
      frequencyDesc: {
        everyTransaction: "Riceverai un payout crypto dopo ogni pagamento confermato.",
        daily: "I payout vengono accumulati e inviati una volta al giorno.",
        weekly: "I payout vengono accumulati e inviati ogni lunedì.",
        monthly: "I payout vengono accumulati e inviati il 1° del mese."
      },
      saveConfig: "Salva Wallet",
      configSaved: "Wallet salvato! Riceverai i payout in crypto.",
      howItWorks: "Come Funziona",
      step1: "Cliente paga",
      step1Desc: "Il cliente paga con carta, PayPal, etc.",
      step2: "Commissione dedotta",
      step2Desc: "La commissione piattaforma viene trattenuta",
      step3: "Conversione automatica",
      step3Desc: "L'importo viene convertito in {token} al tasso corrente",
      step4: "Payout su Polygon",
      step4Desc: "{token} inviati al tuo wallet",
      activeConfig: "Configurazione attiva",
      payoutsSentTo: "I payout verranno inviati a",
      payoutHistory: "Storico Payout",
      noPayoutsYet: "Nessun payout ancora",
      payoutsWillAppear: "I payout appariranno qui dopo la configurazione"
    },
    // Validation
    enterWalletAddress: "Inserisci un indirizzo wallet Polygon",
    invalidWalletAddress: "Indirizzo wallet non valido. Deve iniziare con 0x e avere 42 caratteri",
    errorLoading: "Errore nel caricamento dei dati",
    errorSaving: "Errore nel salvataggio",
    copied: "Copiato!",
    error: "Errore"
  },

  subscription: {
    notFound: "Piano non trovato", processing: "Abbonamento in elaborazione...", emailRequired: "Inserisci la tua email", invalidEmail: "Email non valida",
    approvalUrlMissing: "Errore: URL approvazione non trovato", createError: "Errore creazione abbonamento", activated: "Abbonamento Attivato!",
    thankYou: "Grazie per esserti abbonato. Riceverai una conferma via email.", backToSite: "Torna al Sito", closeWindow: "Chiudi Finestra",
    activationPending: "Il tuo abbonamento è in fase di attivazione.", cancelled: "Abbonamento Annullato", cancelledMessage: "Hai annullato la procedura di abbonamento. Puoi riprovare quando vuoi.",
    back: "Torna Indietro", offeredBy: "Offerto da", securePayment: "Pagamento sicuro con Hola Pay", easyCancellation: "Cancellazione facile in qualsiasi momento",
    automaticCharge: "Addebito automatico", nameOptional: "Nome (opzionale)", processingPayment: "Elaborazione pagamento...", subscribeNow: "Abbonati Ora",
    securePaymentVia: "Pagamento sicuro tramite Hola Pay", poweredBy: "Powered by", intervals: { weekly: "settimana", monthly: "mese", quarterly: "trimestre", yearly: "anno" }
  },
  terminals: {
    comingSoon: "Prossimamente disponibile", mainFeatures: "Funzionalità Principali", mainFeaturesDesc: "Tutto ciò di cui hai bisogno per accettare pagamenti in modo professionale",
    forEverySector: "Perfetto per ogni settore", forEverySectorDesc: "Soluzioni personalizzate per la tua attività", availableSoon: "Presto disponibile",
    beFirst: "Vuoi essere tra i primi?", ctaDescription: "Lascia il tuo contatto e ti avviseremo non appena i terminali saranno disponibili. I primi 50 merchant riceveranno",
    exclusiveTerms: "condizioni esclusive", notifyMe: "Notificami", questions: "Hai domande?", questionsDesc: "Il nostro team commerciale è a tua disposizione per rispondere a tutte le tue domande sui terminali POS."
  },
  monitoring: {
    title: "Monitoraggio Sistema", loading: "Caricamento metriche...", unavailable: "Snapshot non disponibile", refreshNow: "Aggiorna ora",
    historyLoadError: "Errore caricamento storico alert", testSentVia: "Alert di test inviato via", noChannels: "nessun canale attivo",
    testSendError: "Errore invio test", backendUptime: "Uptime backend", activeThreads: "Threads attivi", payoutQueue: "Coda payout",
    failedHour: "Falliti 1h", activeLocks: "Lock attivi", transactionsToday: "TX oggi", latestAlerts: "Ultimi alert", noAlerts: "Nessun alert nello storico"
  },
  // Donations
  donate: {
    badge: "Donazione",
    causeNotFound: "Causa non trovata",
    causeNotFoundDesc: "Questa causa di donazione non esiste o non è più attiva.",
    goal: "Obiettivo",
    reached: "raggiunto",
    donors: "donatori",
    selectAmount: "Seleziona un importo",
    customAmount: "Inserisci importo personalizzato",
    anonymous: "Dona in modo anonimo",
    yourName: "Il tuo nome",
    namePlaceholder: "Mario Rossi",
    yourEmail: "La tua email",
    emailPlaceholder: "mario@example.com",
    emailRequired: "Email obbligatoria per donazioni non anonime",
    message: "Messaggio (opzionale)",
    messagePlaceholder: "Lascia un messaggio di supporto...",
    donateNow: "Dona Ora",
    processing: "Elaborazione...",
    secure: "Pagamento sicuro e protetto",
    poweredBy: "Powered by",
    error: "Errore durante la donazione. Riprova.",
    success: "Grazie per la tua donazione!",
    // Admin
    causes: "Cause Donazioni",
    newCause: "Nuova Causa",
    editCause: "Modifica Causa",
    causeTitle: "Titolo Causa",
    causeDescription: "Descrizione",
    goalAmount: "Obiettivo Raccolta",
    suggestedAmounts: "Importi Suggeriti",
    minAmount: "Importo Minimo",
    maxAmount: "Importo Massimo",
    assignToMerchant: "Assegna a Merchant",
    selectMerchant: "Seleziona Merchant",
    notAssigned: "Non assegnato",
    totalRaised: "Totale Raccolto",
    donationCount: "Numero Donazioni"
  }
};

Object.assign(it, {
  apiKeysUi: {
    confirmDelete: "Sei sicuro di voler eliminare questa chiave API?",
    quickGuide: "Guida rapida all’integrazione", exampleRequest: "Esempio di richiesta",
    copyCurlExample: "Copia esempio cURL", fullDocumentation: "Documentazione completa"
  },
  transactionsUi: {
    removeDuplicatesConfirm: "Rimuovere le transazioni duplicate? Verrà mantenuta solo la più vecchia per ogni ID.",
    statusPartiallyRefunded: "Rimborso parziale", defaultStatusSaved: "Stato predefinito salvato",
    defaultStatusError: "Impossibile salvare lo stato predefinito", saveDefaultHint: "Salva lo stato corrente come predefinito per i prossimi accessi",
    defaultLabel: "Predefinito", setDefaultLabel: "Imposta come predefinito", statusReconciled: "Riconciliato (polling)",
    type: "Tipo", allTypes: "Tutti i tipi", allStatuses: "Tutti gli stati", allGateways: "Tutti i gateway",
    allMerchants: "Tutti i merchant", selectDate: "Seleziona una data", dateFrom: "Data da", dateTo: "Data a",
    clearFilters: "Azzera filtri", noFilterMatches: "Nessuna transazione corrisponde ai filtri selezionati",
    loadMoreTransactions: "Carica altre {count} transazioni", visibleOfTotal: "({current} di {total})",
    loadNextPage: "Carica la pagina successiva", refundDate: "Data rimborso", resultsCount: "{count} transazioni trovate"
  },
  cryptoPayoutUi: {
    selectMerchant: "Seleziona prima un merchant", selectAgent: "Seleziona prima un agente",
    agentEnabled: "Crypto payout abilitato per l'agente", agentDisabled: "Agente disabilitato", agent: "Agente",
    agentsTitle: "Crypto payout per gli agenti", agentsDescription: "Configura i payout automatici in crypto per gli agenti",
    noAgentsFound: "Nessun agente trovato", configureAgent: "Configura il crypto payout dell'agente",
    chooseMerchant: "Scegli un merchant", queueSelected: "Accoda selezionati ({count})",
    noMissedInstantPayouts: "Nessun payout istantaneo non elaborato trovato nelle ultime 48 ore",
    noEligibleMissedPayouts: "Nessun payout mancante idoneo",
    noPayoutsQueued: "Nessun payout accodato: lo stato potrebbe essere cambiato",
    totalOnChainPayouts: "Payout on-chain totali", totalOnChainSummary: "Payout on-chain totali (USDC + USDT + USDA)",
    confirmRetryQueuedPayouts: "Ritentare {count} payout in coda? L’azione può inviare trasferimenti crypto reali.",
    confirmRecoverStaleQueue: "Questa azione rimette in coda solo gli elementi bloccati per cui è provato che nessun invio è stato autorizzato. Non invia nulla ora, ma un retry automatico potrebbe elaborare in seguito gli elementi idonei. Continuare?",
    recoveryComplete: "Recupero coda completato: {requeued} rimessi in coda in sicurezza · {review} da verificare · {skipped} invariati. Questa azione non invia trasferimenti; gli elementi idonei potrebbero essere ritentati automaticamente.",
    noStaleItemsRecovered: "Nessun elemento bloccato poteva essere recuperato in sicurezza.",
    queuePayoutsAutoEnabled: "Accodare questi payout? L’elaborazione automatica è attiva e può avviare trasferimenti crypto reali senza un’altra verifica.",
    queuePayoutsAutoDisabled: "Accodare questi payout? Resteranno in coda finché non sarà attiva l’elaborazione automatica.",
    skippedCount: " · saltati: {count}", payoutsQueued: "Payout accodati: {count}{skipped}",
    findMissedPayouts: "Verifica payout mancanti", recoverStale: "Recupera elementi bloccati",
    processing: "In elaborazione", requiresReview: "Da verificare",
    queueRecoveryWarning: "{processing} in elaborazione, {review} da verificare. Non sono inclusi nei retry; riconciliarli prima di intervenire.",
    roxpayActiveIntents: "Intenti payout RoxPay attivi",
    roxpayIntentsDescription: "Stato dell’outbox RoxPay, aggiornato automaticamente ogni 30 secondi. Gli invii già passati alla coda sono visibili nella tabella sottostante.",
    roxpayIntentsUnavailable: "Stato degli intenti RoxPay non disponibile. Aggiorna il backend o riprova.",
    noRoxpayActiveIntents: "Nessun intento RoxPay attivo nell’outbox.",
    roxpayIntentsTruncated: "Sono mostrati al massimo 200 intenti attivi.",
    refreshRoxpayIntents: "Aggiorna lo stato degli intenti RoxPay",
    recipient: "Destinatario", transaction: "Transazione", mode: "Modalità",
    attemptsAndNextStep: "Tentativi e prossima scadenza",
    outboxProcessing: "In elaborazione", outboxPending: "In attesa",
    outboxAwaitingApproval: "In attesa di approvazione", outboxBlocked: "Bloccato",
    outboxAutomatic: "Automatico", outboxManual: "Manuale",
    attempts: "Tentativi", leaseUntil: "Lease fino a", nextAttempt: "Prossimo tentativo",
    createdAt: "Creato", lastError: "Ultimo errore",
    missedInstantPayoutsTitle: "Payout istantanei mancanti",
    automaticProcessingEnabled: "L’elaborazione automatica è attiva. I payout accodati possono avviare trasferimenti crypto reali.",
    automaticProcessingDisabled: "L’elaborazione automatica è disattivata. I payout resteranno in attesa finché non sarà attivata.",
    disable: "Disabilita"
  },
  terminalDetails: {
    featureContactlessTitle: "Contactless & NFC",
    featureContactlessDescription: "Accetta pagamenti tap-to-pay con carte, smartphone e smartwatch. Transazioni istantanee in meno di 2 secondi.",
    featureChipPinTitle: "Chip & PIN",
    featureChipPinDescription: "Supporto completo per carte con chip EMV e PIN. Massima sicurezza per transazioni di alto valore.",
    featurePreauthorizationTitle: "Pre-autorizzazioni",
    featurePreauthorizationDescription: "Perfetto per hotel e autonoleggi. Blocca importi sulla carta del cliente e addebita solo l'importo finale.",
    featureReceiptsTitle: "Ricevute digitali",
    featureReceiptsDescription: "Invia ricevute via SMS, email o WhatsApp. Zero carta, massima professionalità e tracciabilità.",
    featureTipsTitle: "Mance digitali",
    featureTipsDescription: "Suggerisci importi di mancia sul display. Aumenta le mance del tuo staff fino al 30%.",
    featureConnectivityTitle: "Connettività 4G/Wi-Fi",
    featureConnectivityDescription: "Funziona ovunque con doppia connettività. Ideale per consegne, eventi e mercati.",
    advancedHotelPreauthorization: "Pre-autorizzazioni per hotel (check-in anticipato)",
    advancedCarRentalPreauthorization: "Pre-autorizzazioni per autonoleggi",
    advancedRestaurantOrders: "Ordini e pagamenti al tavolo per ristoranti",
    advancedRetailInventory: "Inventario integrato per retail",
    advancedOperatorReports: "Multi-operatore con report individuali",
    advancedMultiCurrency: "Accettazione multi-valuta (EUR, USD, GBP)",
    advancedLiveNotifications: "Notifiche in tempo reale su ogni transazione",
    advancedWhatsappReceipts: "Ricevute WhatsApp automatiche",
    advancedBrandedEmailReceipts: "Ricevute email personalizzate con logo",
    advancedDailyReports: "Report giornalieri automatici",
    advancedPciCertification: "Certificazione PCI-DSS Level 1",
    advancedSupport: "Supporto clienti dedicato 24/7",
    sectorRestaurants: "Ristoranti e bar", sectorHotels: "Hotel e B&B",
    sectorRetail: "Retail e negozi", sectorFoodTrucks: "Food truck",
    sectorCarRental: "Autonoleggi", sectorProfessionals: "Professionisti",
    advancedBadge: "Funzionalità avanzate", advancedTitle: "Tutto incluso, senza sorprese",
    advancedDescription: "Funzionalità enterprise disponibili per ogni tipo di attività",
    heroTitle: "Terminali POS",
    heroSubtitle: "Accetta pagamenti fisici con i nostri terminali di ultima generazione. Un unico pannello per gestire vendite online e in negozio.",
    contactlessBadge: "Contactless", realtimeBadge: "In tempo reale",
    notifyWhatsappMessage: "Ciao! Vorrei essere avvisato quando i terminali POS Alpha Bit Pay saranno disponibili.",
    notifyButton: "Avvisami quando è disponibile", transactionTime: "Tempo transazione",
    uptimeGuarantee: "Uptime garantito", dedicatedSupport: "Supporto dedicato", monthlyFee: "Canone mensile",
    contactWhatsappMessage: "Ciao! Vorrei informazioni sui terminali POS Hola Pay."
  }
});
Object.assign(it.monitoring, { errorRate: "Tasso di errore" });

export default it;
